module.exports = function getResource (label) {
    const resources = { default: 'Default' };

    return resources[label];
};
